type Props = (username?: string) => boolean;

const isGuestUser: Props = (username) => {
  return !!username && username?.startsWith("guest_");
};

export default isGuestUser;
